(() => {
  if (customElements.get('bg-delivery-countdown')) return;
  const DAY = 86400000;
  class BGDeliveryCountdown extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      try {
        this.zone = this.dataset.timezone.trim() || 'Europe/London';
        this.clock = new Intl.DateTimeFormat('en-GB', {
          timeZone: this.zone, year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
        });
        this.days = new Set(this.dataset.days.split(',').filter(Boolean).map(Number));
        this.exclusions = new Set(this.dataset.exclusions.split(/[\s,;]+/).filter(Boolean));
        this.hour = Number(this.dataset.hour);
        this.minute = Number(this.dataset.minute);
        this.transit = Number(this.dataset.transit);
        if (!this.days.size) throw new Error('Select at least one working day.');
        this.countdown = this.querySelector('[data-countdown]');
        this.delivery = this.querySelector('[data-delivery]');
        this.current = null;
        this.timer = setInterval(() => this.tick(), 1000);
        this.tick();
      } catch (error) { this.fail(error); }
    }
    disconnectedCallback() { clearInterval(this.timer); }
    parts(epoch) {
      const p = {};
      this.clock.formatToParts(new Date(epoch)).forEach(part => {
        if (part.type !== 'literal') p[part.type] = Number(part.value);
      });
      return p;
    }
    civil(p) { return Date.UTC(p.year, p.month - 1, p.day, p.hour || 0, p.minute || 0, p.second || 0); }
    cutoff(day) {
      // Convert the dispatch date's local cutoff to an instant, using that date's
      // timezone offset (including daylight saving), never the shopper's zone.
      const target = day + this.hour * 3600000 + this.minute * 60000;
      let epoch = target;
      for (let i = 0; i < 6; i++) {
        const delta = target - this.civil(this.parts(epoch));
        if (delta === 0) return epoch;
        epoch += delta;
      }
      throw new Error('The cutoff is not a valid local time. Choose another cutoff.');
    }
    working(day) {
      return this.days.has(new Date(day).getUTCDay()) &&
        !this.exclusions.has(new Date(day).toISOString().slice(0, 10));
    }
    schedule(now) {
      const p = this.parts(now);
      let day = Date.UTC(p.year, p.month - 1, p.day);
      let deadline;
      let found = false;
      for (let i = 0; i < 3660; i++, day += DAY) {
        if (!this.working(day)) continue;
        deadline = this.cutoff(day);
        if (deadline > now) { found = true; break; }
      }
      if (!found) throw new Error('No available dispatch date. Check working days and excluded dates.');
      const dispatch = day;
      let remaining = this.transit;
      for (let i = 0; remaining > 0 && i < 3660; i++) {
        day += DAY;
        if (this.working(day)) remaining--;
      }
      if (remaining) throw new Error('No available delivery date. Check excluded dates.');
      return { deadline, dispatch, delivery: day };
    }
    tick() {
      try {
        const now = Date.now();
        if (!this.current || now >= this.current.deadline || now < this.lastNow) {
          this.current = this.schedule(now);
          this.delivery.textContent = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short'
          }).format(new Date(this.current.delivery));
        }
        this.lastNow = now;
        const seconds = Math.max(0, Math.ceil((this.current.deadline - now) / 1000));
        this.countdown.textContent = Math.floor(seconds / 3600) + 'h ' +
          Math.floor(seconds % 3600 / 60) + 'm ' + seconds % 60 + 's';
        this.hidden = false;
      } catch (error) { this.fail(error); }
    }
    fail(error) {
      clearInterval(this.timer);
      this.hidden = true;
      if (window.Shopify && window.Shopify.designMode) {
        this.querySelector('[data-message]').hidden = true;
        const note = this.querySelector('[data-error]');
        note.textContent = 'Delivery countdown: ' + error.message;
        note.hidden = false;
        this.hidden = false;
      }
    }
  }
  customElements.define('bg-delivery-countdown', BGDeliveryCountdown);
})();
